import { useSearchParams } from 'react-router-dom';
import { AppHeader } from '@/components/AppHeader';
import { Banner } from '@/components/Banner';
import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { isDirectoryExperience } from '@/features/experiences/lib/directoryTags';
import { EMBED_QUERY_PARAM } from '@/features/experiences/lib/embed';
import { isEditRole } from '@/features/permissions/lib/permissions.lib';
import { HeaderActions } from './HeaderActions';
import { PublicViewNotice } from './PublicViewNotice';

export const PageHeader = () => {
  const { experience, readOnly } = usePageExperienceContext();
  const { role } = experience;
  const hasEdit = Boolean(role && isEditRole(role));

  // An embedded page is previewed by the person who just made it, alongside
  // their own tools for it, so the app's top nav (logo, account menu) and the
  // notice pointing them to the editor only show on the page itself.
  const [searchParams] = useSearchParams();
  const isEmbedded = searchParams.has(EMBED_QUERY_PARAM);
  const showPublishedPageOwnerBanner = readOnly && hasEdit && !isEmbedded;

  const hasSchoolsTag = isDirectoryExperience(experience);

  return (
    <>
      {hasSchoolsTag && <Banner />}
      {!isEmbedded && (
        <AppHeader
          actions={
            <HeaderActions experience={experience} readOnly={readOnly} />
          }
        />
      )}
      {showPublishedPageOwnerBanner && (
        <PublicViewNotice experience={experience} />
      )}
    </>
  );
};
